export default "__VITE_ASSET__BcxgRnDW__"